export async function GetProgramOptions(self) {
    self.$HttpClient.commonService.url = "Programs/GetProgramOptions";
    self.$HttpClient.commonService.get()
        .then(r => r.json())
        .then(json => {
            self.obj.ProgramsOptions = json.model;
            self.$nextTick(function () { $('.selectpicker').selectpicker('refresh') });
        });
}
export function SaveInterestedPartner(self) {
    if (self.formValid) {
        self.$HttpClient.commonService.url = "Programs/SaveInterestedPartner";
        self.$HttpClient.commonService.post(self.obj).then(async response => {
            const data = await response.json();
            if (data.isSuccess) {
                self.$swal.fire({
                    icon: 'success',
                    title: self.$t('InterestedPartner-SentSuccessfully'),
                    showCancelButton: false,
                    text: self.$t('InterestedPartner-SentSuccessMsg'),
                    confirmButtonText: self.$t('InterestedPartner-Close'),
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-secondary ms-2'
                    },
                    buttonsStyling: false
                }).then(function () {
                    self.$router.push({ path: process.env.BASE_URL })
                });                
            }
            else {
                self.$CommonFunction.ShowErrorMsg(self.$swal, data.error);
            }
        })
            .catch(error => {
                this.errorMessage = error;
                console.error(self.$t('errorMsg'), error);
            });
    }
}